<template>
  <panel :title="$tc('general.club')">
    <template v-if="isAdmin" #actions>
      <el-button-group>
        <el-button
          :type="clubsView === 'deleted' ? 'default' : 'primary'"
          size="medium"
          round
          @click="setView('active')">
          {{ $tc('club.active_clubs') }}
        </el-button>
        <el-button
          :type="clubsView === 'deleted' ? 'primary' : 'default'"
          icon="el-icon-delete"
          size="medium"
          round
          @click="setView('deleted')">
          {{ $tc('club.deleted_clubs') }}
        </el-button>
      </el-button-group>
    </template>

    <error-box v-if="error" :loading="loading" @reload="load()" />

    <clubs-table
      v-if="!error && clubsView === 'active'"
      :data="clubs"
      :loading="loading"
      :full-options="user ? user.isAdmin : false"
      :show-points="true" />

    <clubs-table
      v-else-if="!error"
      :data="deletedClubs"
      :loading="loadingDeleted"
      :full-options="isAdmin"
      :show-points="true"
      :show-restore="true"
      @restore="onRestored" />
  </panel>
</template>

<script>
import ClubsTable from '@/components/clubs/ClubsTable'

export default {
  components: {
    ClubsTable
  },

  data () {
    return {
      error: false,
      loading: false,
      loadingDeleted: false,
      clubsView: 'active'
    }
  },

  computed: {
    clubs () {
      const list = this.$store.getters['clubs/list'] || []
      const filtered = list.filter(club => !club.isBlocked && !club.isDeleted)
      const rankedClubs = this.$store.getters['ranking/clubs'] || []
      return filtered.map(club => {
        const ranked = rankedClubs.find(r => r.id === club.id)
        const points = ranked && ranked.points != null ? ranked.points : (club.earnedPoints != null ? club.earnedPoints : 0)
        return { ...club, points }
      })
    },

    deletedClubs () {
      return this.$store.getters['clubs/deletedList'] || []
    },

    user () {
      return this.$store.state.auth.user
    },

    isAdmin () {
      return this.user ? !!this.user.isAdmin : false
    }
  },

  created () {
    this.load()
  },

  methods: {
    setView (view) {
      if (this.clubsView === view) return
      this.clubsView = view
      if (view === 'deleted') this.loadDeleted()
    },

    async load () {
      this.loading = true
      try {
        await Promise.all([
          this.$store.dispatch('clubs/load'),
          this.$store.dispatch('ranking/loadClubs')
        ])
        this.error = false
      } catch (e) {
        console.error(e)
        this.error = true
      } finally {
        this.loading = false
      }
    },

    async loadDeleted () {
      this.loadingDeleted = true
      try {
        await this.$store.dispatch('clubs/loadDeleted')
        this.error = false
      } catch (e) {
        console.error(e)
        this.error = true
      } finally {
        this.loadingDeleted = false
      }
    },

    onRestored () {
      // The restored club belongs in the active list again.
      this.load()
    }
  }
}
</script>
